/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { CenterSupplier } from './CenterSupplier';
import {
    CenterSupplierFromJSON,
    CenterSupplierFromJSONTyped,
    CenterSupplierToJSON,
    CenterSupplierToJSONTyped,
} from './CenterSupplier';

/**
 * 
 * @export
 * @interface ResponseCenterSupplier
 */
export interface ResponseCenterSupplier {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseCenterSupplier
     */
    result: ResponseResult;
    /**
     * 
     * @type {CenterSupplier}
     * @memberof ResponseCenterSupplier
     */
    data: CenterSupplier;
}

/**
 * Check if a given object implements the ResponseCenterSupplier interface.
 */
export function instanceOfResponseCenterSupplier(value: object): value is ResponseCenterSupplier {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseCenterSupplierFromJSON(json: any): ResponseCenterSupplier {
    return ResponseCenterSupplierFromJSONTyped(json, false);
}

export function ResponseCenterSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCenterSupplier {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': CenterSupplierFromJSON(json['data']),
    };
}

export function ResponseCenterSupplierToJSON(json: any): ResponseCenterSupplier {
    return ResponseCenterSupplierToJSONTyped(json, false);
}

export function ResponseCenterSupplierToJSONTyped(value?: ResponseCenterSupplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': CenterSupplierToJSON(value['data']),
    };
}

